import type { SimpleSearchFilter } from 'module/api/filter/types';
import type { ReactNode } from 'react';

export enum ViewType {
  ProjectList = 'PROJECT_LIST',
  ProjectTaskList = 'PROJECT_TASK_LIST',
  AllTasks = 'ALL_TASKS',
  ResourceManagement = 'RESOURCE_MANAGEMENT',
  TimesheetReports = 'TIMESHEET_REPORTS',
  CsatReports = 'CSAT_REPORTS',
  ProjectPerformanceReports = 'PROJECT_PERFORMANCE_REPORTS',
  PeoplePerformanceReports = 'PEOPLE_PERFORMANCE_REPORTS',
  OperationReports = 'OPERATION_REPORTS',
  IntervalIqReports = 'INTERVAL_IQ_REPORTS',
  ProfitabilityReports = 'PROFITABILITY_REPORTS',
  Dashboard = 'DASHBOARD_FILTER',
  UtilizationReport = 'UTILIZATION_REPORT',
  TimesheetSubmissionReport = 'TIMESHEET_SUBMISSION_REPORT',
  UserTimeAnalyticsReport = 'USER_TIME_ANALYTICS_REPORT',
  ProjectTimeAnalyticsReport = 'PROJECT_TIME_ANALYTICS_REPORT',
  CateogryTimeAnalyticsReport = 'CATEGORY_TIME_ANALYTICS_REPORT',
  SprintList = 'SPRINT_LIST',
  SprintReports = 'SPRINT_REPORT',
  CustomerPorfolioList = 'COMPANY_LIST',
  CustomReport = 'CUSTOM_REPORT',
  SkillMatrix = 'SKILL_MATRIX',
  ResourceRequest = 'RESOURCE_REQUEST',
  ResourceApproval = 'RESOURCE_APPROVAL',
  InvoiceList = 'INVOICE_LIST',
  TimesheetApprovals = 'TIMESHEET_APPROVALS',
  ProjectTimesheetsList = 'PROJECT_TIMESHEETS_LIST',
  TimesheetsList = 'ACCOUNT_TIMESHEETS_LIST',
  MyExpenses = 'MY_EXPENSES',
  AllSignal = 'ALL_SIGNAL',
}

export enum ViewAvailability {
  OnlyMe = 'ONLY_ME',
  AllTeamMembers = 'ALL_TEAM_MEMBERS',
}

type ViewFilterShareConfigType = {
  sharedWithCustomerPortal: boolean;
  shareWithProjects?: boolean;
  shareWithAllProjects?: boolean;
  filter?: SimpleSearchFilter;
};

export interface View<ViewDefinition> {
  viewId: number;
  viewName: string;
  viewDefinition: ViewDefinition;
  viewIcon?: ReactNode;
  createdBy: number;
  viewType: ViewType;
  self: boolean;
  hidden?: boolean; // User-level customisation
  viewSourceId?: number;
  viewFilterShareConfig?: ViewFilterShareConfigType;
}

export interface ViewCustomisationUpdate {
  viewId: number;
  hidden?: boolean;
  position?: number;
}

export interface ViewCustomisationPayload {
  viewType: ViewType;
  viewSourceId: number | null;
  shared: boolean;
  updates: ViewCustomisationUpdate[];
}
